export const getMainColor = state =>
  state.eventEmbedSettings.data
    ? state.eventEmbedSettings.data.mainColor
    : '#399ba2';
export const getBackgrounColor = state =>
  state.eventEmbedSettings.data
    ? state.eventEmbedSettings.data.backgroundColor
    : '#fff';
